{
  "en": {
    "answers": [],
    "tags": [
      {
        "id": 22080,
        "name": "Evaluation"
      },
      {
        "id": 156068,
        "name": "Sample Question"
      },
      {
        "id": 156081,
        "name": "Freetext"
      },
      {
        "id": 156083,
        "name": "Survey Question"
      }
    ],
    "text": "1. Which aspects of the course did you particularly like?\n2. What could be improved in the course?",
    "display_in_order": true,
    "is_poll_question": true,
    "type": 3,
    "created_at": "2025-09-02T17:21:39.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:58:45.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "max_num_characters": 400,
    "max_answer_submissions": 2,
    "explanation": "### In the first field, participants can freely formulate their impressions.\n### In the second field, participants can freely formulate their improvement suggestions.\n\nThis makes it possible to collect **differentiated feedback**, providing a more comprehensive picture of learners’ experiences, opinions, and preferences. Open-ended responses complement closed formats such as multiple-choice questions, as they reveal **individual perspectives and details** that may not be captured through predefined options.\nThis allows for collecting **differentiated feedback**, providing a more comprehensive picture of learners’ experiences, opinions, and preferences. Open-ended responses complement closed formats such as multiple-choice questions, as they reveal **individual perspectives and details** that may not be captured through predefined options.",
    "has_explanation": true,
    "num_answers": 0
  },
  "de": {
    "answers": [],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 14279,
        "name": "Umfragen/Evaluationen"
      },
      {
        "id": 35384,
        "name": "Feedback"
      }
    ],
    "text": "1. Welche Aspekte des Kurses haben Dir besonders gefallen?\n2. Was könnte im Kurs verbessert werden?",
    "display_in_order": true,
    "is_poll_question": true,
    "type": 3,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:33:41.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "max_num_characters": 400,
    "max_answer_submissions": 2,
    "explanation": "### In dieser offenen Frage können Teilnehmende ihre Eindrücke frei formulieren. \n\nSo lassen sich **differenzierte Rückmeldungen** sammeln, die ein umfassenderes Bild der Erfahrungen, Einstellungen und Präferenzen geben. Offene Antworten ergänzen geschlossene Formate wie Multiple-Choice-Fragen ideal, da sie **individuelle Sichtweisen und Details** sichtbar machen, die in vorgegebenen Auswahlmöglichkeiten nicht abgebildet wären.",
    "has_explanation": true,
    "num_answers": 0
  }
}
